import validate from "C:/Users/Nabil/Desktop/find_app/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45404_45global from "C:/Users/Nabil/Desktop/find_app/middleware/redirect-404.global.js";
export const globalMiddleware = [
  validate,
  redirect_45404_45global
]
export const namedMiddleware = {
  auth: () => import("C:/Users/Nabil/Desktop/find_app/middleware/auth.ts")
}